import { connect } from 'react-redux';

import {
  openLightbox,
  selectMapLayer,
  deselectMapLayer,
  zoomToLayerExtent,
} from '../actions';
import LayersList from '../components/LayersList';

const mapStateToProps = ({ mapLayers, sidebar }, { height }) => {
  const { dataLayers, activeLayers } = mapLayers;
  const { selectedTab } = sidebar;
  return {
    activeLayers,
    dataLayers,
    height,
    selectedTab,
  };
};

export default connect(mapStateToProps, {
  openLightbox,
  selectMapLayer,
  deselectMapLayer,
  zoomToLayerExtent,
})(LayersList);



// WEBPACK FOOTER //
// ./src/containers/LayersListConnected.jsx